//Componentes Generales
import React, { useState, useContext, useEffect, useRef, useCallback} from 'react';
import moment from "moment";

import { useNavigate } from 'react-router-dom';

//Tipos de Prioridades
import { PRIORITY, PRIORITYIN } from '../../utils/priority';
import Select from 'react-select';

//Estructuras
import { createEstructuraChecklistsByProcedimiento, createEstructuraProveedor, estructuraImputaciónRRHH, estructuraOrdenTrabajo } from '../../utils/estructuras';

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

// Estilos
import './FormReq.css'
import {COLOR_BOTONES} from '../../constants/colors';

//Components
import BtnArchivos from '../BtnArchivos/BtnArchivos';
import ModuloItem from '../ModuloItem/ModuloItem';
//Contexto
import activoContext from '../../context/activoContex/activoContex';
import agregarReqContext from '../../context/agregarReq/agregarReqContext';

import { estructuraTarea, estructuraPeligro, estructuraEpp, estructuraHerramienta, estructuraEqpg, estructura_producto } from '../../utils/estructuras';
import authContext from '../../context/authentication/authContex';
import productsContext from '../../context/productos/productsContext';
import ProductosSubtabla from '../productosSubtabla/ProductosSubtabla';
import TareasSubtabla from '../tareasSubtabla/TareasSubtabla';
import PeligrosSubtabla from '../peligrosSubtabla/PeligrosSubtabla';
import EppsSubtabla from '../eppsSubtabla/EppsSubtabla';
import HerramientasSubtabla from '../herramientasSubtabla/HerramientasSubtabla';
import EqpgsSubtabla from '../eqpgsSubtabla/EqpgsSubtabla';
import ImputacionRRHHSubtabla from '../imputacionRRHHSubtabla/ImputacionRRHHSubtabla';
import ChecklistsSubtabla from '../checklistsSubtabla/ChecklistsSubtabla';
import { parse } from '@fortawesome/fontawesome-svg-core';
import Swal from 'sweetalert2';
import ControlesSubtabla from '../controlestSubtabla/ControlesSubtabla';
import ServTercerosSubtabla from '../servTercerosSubtabla/ServTercerosSubtabla';

// Constante con estructura del producto.



/*
    Componente encargado de mostrar el formulario de requerimiento.
        Donde edicion determina si mostrar algunas cosas y a que logica seguir en el guardado.
              req es la estructura del requerimiento.
              files son los archivos que almacena/ra el requerimiento.
              itemList son los items/productos del requerimeinto.
              productList son los productos disponibles.
              guardarReq es la función del context que guarda el requerimiento.
              cerrar es la función encargada de ocultar el dialogo.
*/
function FormReq({ req, edicion, files = [], guardarReq, cerrar, procedimiento={}, procedimientos=[], mode}) {
    const navigate = useNavigate();

    //State del requerimiento.
    const [requeriment, setRequeriment] = useState((req != undefined) ? {...req} : {...JSON.parse(JSON.stringify(estructuraOrdenTrabajo))});

    const [tablaSeleccionada,setTablaSeleccionada] = useState('tareas');
    const [mostrarControles, setMostrarControles] = useState(true);

    //Context Edit Requerimiento
    const addContext = useContext(agregarReqContext);
    const { guardarRequerimiento, editarRequerimientoBE } = addContext;
    const ahContext = useContext(authContext);
    const {usuario, hasWebServiceConfigured, globalSettings} = ahContext

    // opciones para que se puedan ver todos los nombre de los activos
    const {activoList} = useContext(activoContext)

    //Productos del ABM, para tomar el precio actual de los materiales que vienen de procedimientos.
    const { products: productsABM } = useContext(productsContext);
    const preciosABMAplicadosRef = useRef(false);
    const optionsActivos = activoList?.map((dato) =>({ value: dato.name, label: dato.name, activoID:dato._id, activoCod: dato.codActivo  })); 
 
    //State que determina la muestra de las opciones de selección de estado.
    const [displayOptions, setDisplayOptions] = useState();
    
    //State de los archivos seleccionados.
    const [selectedFiles, setSelectedFiles] = useState(files);//files
    //State necesario para poder personalizar input de files.
    const [selectionColor, setSelectionColor] = useState(false);
    //State necesario para que el usuario no envie muchas veces el requerimiento cuando aprieta el boton muchas veces
    const [controlBotonEnviar, setControlBotonEnviar] = useState(false);

    const [archivoTotal,setArchivoTotal] = useState([]);

    const buttonSaveDisabledRef = useRef(false);
    const [buttonSaveDisabled, setButtonSaveDisabled] = useState(false);
    
    const completedTasks = requeriment.tareas?.filter(t => t.done === true).length;

    /*
        Manejador de requerimiento ante cambio de titulo.
            Donde data es el titulo ingresada por el usuario. 
        El parametro data es el valor con el que se setea el titulo del requerimiento.
    */
    const handleChangeTitle = useCallback((data) => {
        setRequeriment((prevReq) => ({ ...prevReq, title: data }));
    },[]);

    /*
        Manejador de requerimiento ante cambio de fecha Entrega.
            Donde data es la fecha Entrega ingresada por el usuario. 
        El parametro data es el valor con el que se setea la fecha Entrega del requerimiento.
    */
    const handleChangeDeliveryData = useCallback((data) => {
        const fecha = new Date(data.concat("T15:00:00.000Z"));
        setRequeriment((prevReq) => ({ ...prevReq, deliveryDate: fecha }));
    },[]);

    /*
        Manejador de requerimiento ante cambio de observación.
            Donde data es la observación ingresada por el usuario. 
        El parametro data es el valor con el que se setea la observación del requerimiento.
    */
    const handleChangObservation = (data) => {
        setRequeriment({ ...requeriment, observ: data });
    }

    /*
        Manejador ante selección de una prioridad.
            Donde priorIndex es el codigo identificativo de la prioridad.
        Al setear la prioridad en el requerimiento, se oculta el desplegable de opciones de prioridades disponibles.
    */
    const seleccionarPriority = (priorIndex) => {
        displayOpciones();
        setRequeriment({ ...requeriment, priority: priorIndex });
    }

    /* 
        Determina si se muestra o no el display de opciones de prioridades.
    */
    const displayOpciones = () => {
        displayOptions ? setDisplayOptions(false) : setDisplayOptions(true);
    }

    /*
        Guarda el requerimiento mediante función del context.
        Distintos comportamientos segun variable edición.
    */
    const handleSaveRequirement = async () => {
        if(buttonSaveDisabledRef.current) return;         
        buttonSaveDisabledRef.current = true;

        let reqModelado = {...requeriment};
        let tareasCompletadas = reqModelado.tareas.filter(t => t.label != '');
        let peligrosCompletados = reqModelado.peligros ? reqModelado.peligros.filter(p => p.label != '') : [];
        let eppsCompletados = reqModelado.epps ? reqModelado.epps.filter(e => e.label != '') : [];
        let herramientasCompletadas = reqModelado.herramientas ? reqModelado.herramientas.filter(h => h.label != '') : [];
        let eqpgsCompletados = reqModelado.eqpgs ? reqModelado.eqpgs.filter(eq => eq.label != '') : [];
        let imputacionesCompletadas = reqModelado.imputaciones.filter(i => i.legajo.label != '');
        let proveedoresCompletadas = reqModelado.proveedores.filter(p => p.proveedor.label != '');
        reqModelado.tareas = tareasCompletadas;
        reqModelado.peligros = peligrosCompletados;
        reqModelado.epps = eppsCompletados;
        reqModelado.herramientas = herramientasCompletadas;
        reqModelado.eqpgs = eqpgsCompletados;
        reqModelado.imputaciones = imputacionesCompletadas;
        reqModelado.proveedores = proveedoresCompletadas;

        const newLista = requeriment.productos.filter((d) => d.artCod !== '');
        let checklistsModelados = [];
        checklistsModelados = reqModelado.checklists ? reqModelado.checklists.map(({_id,...c}) => c) : [];
        reqModelado.checklists = checklistsModelados;
        
        if(reqModelado.imputaciones.length > 0){
            let flag = false;
            let duracionODT = reqModelado.duracion ? reqModelado.duracion : 0;
            reqModelado.imputaciones.forEach((imp,index) => {
                if(imp.cantHoras > duracionODT){
                    flag = true;
                    Swal.fire({
                        icon:'error',
                        title:'Imposible Guardar',
                        text:`La duración del trabajo realizado por ${imp.legajo.label} supera la duración total especificada en la orden de trabajo.`
                    })
                    buttonSaveDisabledRef.current = false;
                    return;
                } 
            })
            if(flag) return;
        }
        
        if(mode != undefined && mode == 'editOTFromActivos'){
            let res = await editarRequerimientoBE(reqModelado, newLista, selectedFiles,[], usuario, 'editingOTFromActivo');
            Swal.fire({
                title:`Se guardo una nueva orden de trabajo!`,
                icon: 'success',
                text: `El numero de orden de trabajo es : ${res.tDocNroFor}`,
                showConfirmButton: true,
                allowEnterKey: true
            })
            setControlBotonEnviar(false);
            (cerrar == undefined) ? navigate('/Home') : cerrar();
        }
        else if (edicion === 'Edicion') {
            Swal.fire("Un aviso se mostrara al finalizar...")
            await guardarReq(reqModelado, newLista, selectedFiles, files)
            setControlBotonEnviar(false); // Habilitar el botón nuevamente
            (cerrar == undefined) ? navigate('/Home') : cerrar();
        } else {
            Swal.fire("Un aviso se mostrara al finalizar...")
            let resp = await guardarReq(reqModelado, selectedFiles);
            // Si la ODT es sobre procedimientos programados, el backend ya los vinculo en el mismo request.
            if(resp){
                setRequeriment({ ...estructuraOrdenTrabajo });
                navigate('/Home')
            }
        }
        
        buttonSaveDisabledRef.current = false;
    }

    // selecciona el activo 
    const handleChengeActivo = (taSelccionado) => {
        setRequeriment({ ...requeriment, activo:{id:taSelccionado.activoID, value: taSelccionado.activoCod, label:taSelccionado.label}});
    }

    const handleChangeCheckTask = useCallback((e,i) => {
        setRequeriment(prevReq => {
            let tareas = prevReq.tareas.slice();
            tareas[i].done = e.target.checked
            return {...prevReq, tareas};
        })
    }, []);

    const handleChangeProductos = (prod={}, i, property = '', value = '', prodsRecuperados = []) => {
        //Se le asigna un id random al item vacio. Esto es para facilitar la eliminación del item en caso de ser necesario.
        setRequeriment((prevReq) => {
            if(prodsRecuperados.length > 0){
                let importeTotalProductos = 0;
                prodsRecuperados.forEach(p => {
                    if(p.precio != undefined) importeTotalProductos += Number.parseInt(p.quantity) * p.precio
                });
                let newReq = {...requeriment, ['productos']:prodsRecuperados, importeTotalProductos:importeTotalProductos};
                return newReq;
            }else{
                const actualList = (prevReq.productos != undefined) ? prevReq.productos.slice() : [{...estructura_producto}];
                
                if(property != '' && value != '' && Object.keys(prod).length == 0){  
                    actualList[i][property] = value;
                }else if(property != ''){
                    actualList[i][property] = value;
                }
                else{
                    const prodTemp = {...prod, user_id: (Math.random() * 100).toString()};
                    const nuevaEstructura = {...estructura_producto, user_id: (Math.random() * 100).toString()};
                    if(prod.tipPro != ''){
                        if(actualList[i].tipPro !== ''){
                            actualList[i] = prodTemp;
                        }else{
                            actualList[i] = prodTemp;
                            actualList.push(nuevaEstructura);
                        }
                    }
                }
                let importeTotalProductos = 0;
                actualList.forEach(p => {
                    if(p.precio != undefined) importeTotalProductos += Number.parseInt(p.quantity) * p.precio
                });
                let newReq = {...requeriment, ['productos']:actualList, importeTotalProductos:importeTotalProductos};
                return newReq;
            }
        })
    }

    const handleDeleteProd = (prod, index) => {
        let actualProductos = requeriment.productos.slice();
        if(prod.tipPro != ''){
            let productosToUpdate = actualProductos.filter((p,i) => i != index);
            setRequeriment({...requeriment,['productos']:productosToUpdate});
        }
    }

    const handleChangeImputaciones = useCallback((categoria = {}, i,  property = '', value = '') =>{
        setRequeriment((prevProc) => {
            const actualList = prevProc.imputaciones.slice();
            if(actualList[i].legajo?.label == '' && property == 'legajo') actualList.push({...estructuraImputaciónRRHH});
            if(property != '' && value != '' && Object.keys(categoria).length == 0){
                actualList[i][property] = value;
            }else if(property != ''){
                actualList[i][property] = value;
            }
            let importeTotalRRHH = 0;
            actualList.forEach(l => {
                if(l.legajo.basico != undefined){
                    l.importe = l.legajo.basico * l.cantHoras;
                    importeTotalRRHH += l.legajo.basico * l.cantHoras;
                }
            })
            return {...prevProc, imputaciones: actualList, importeTotalRRHH};
        })
    }, []);

    const handleDeleteImputaciones = useCallback((imputacion,index) => {
        setRequeriment((prevReq) => {
            let imputaciones = prevReq.imputaciones.slice();
            if(imputaciones.length > 0 && index > -1 && imputacion.legajo.label !== ''){
                imputaciones = prevReq.imputaciones.filter((imp,i) => i !== index);
            }
            return {...prevReq, imputaciones};
        });
    }, []);
    
    const handleChangeProveedores = (categoria = {}, i,  property = '', value = '', proveedoresRecuperados = []) =>{
        setRequeriment((prevProc) => {
            if(proveedoresRecuperados.length > 0){
                // let importeTotalProductos = 0;
                // proveedoresRecuperados.forEach(p => {
                //     if(p.precio != undefined) importeTotalProductos += Number.parseInt(p.quantity) * p.precio
                // });
                let newReq = {...requeriment, ['proveedores']: proveedoresRecuperados};
                return newReq;
            }else{
                const actualList = prevProc.proveedores.slice();
                if(actualList[i].proveedor?.label == '' && property == 'proveedor') actualList.push({...createEstructuraProveedor()});
                if(property != '' && value != ''){  
                    actualList[i][property] = value;
                }else if(property != ''){
                    actualList[i][property] = value;
                }
                let importeTotalProveedores = 0;
                actualList.forEach(p => {
                    if(p.importe != undefined){
                        importeTotalProveedores += p.importe ;
                    } 
                })
                let newProc = {...requeriment, ['proveedores']:actualList, importeTotalProveedores: importeTotalProveedores}
                return newProc;
            }
        })
    }

    const handleDeleteProveedores = (proveedor,index) => {
        setRequeriment((prevReq) => {
            let proveedores = prevReq.proveedores.slice();
            if(proveedores.length > 0 && index > -1 && proveedor.proveedor.label !== ''){
                proveedores = prevReq.proveedores.filter((imp,i) => i !== index);
            }
            let newReq = {...requeriment,['proveedores']:proveedores};
            return newReq;
        });
    }

    const handleChangeEnvioExterno = (e) => {
        setRequeriment({...requeriment,envioExterno:e.target.checked});
    }

    //Sobre un procedimiento unico.
    useEffect(()=>{
        if(procedimiento != undefined && Object.keys(procedimiento).length > 0){
            let reqModelado = { 
                ...requeriment, 
                title:`Orden de Trabajo s/ ${procedimiento.codProc} - ${procedimiento.codActivo}`, 
                activo:{id:procedimiento.activoID, value: procedimiento.codActivo, label:procedimiento.nameActivo},
                observ: `Generando Orden de Trabajo sobre ${procedimiento.codProc} (${procedimiento.nameProcedimiento}) asociado al activo ${procedimiento.codActivo} (${procedimiento.nameActivo}) \nEstado actual: ${(procedimiento.tipoAlerta == 'PorVENC') ? 'Por Vencer' : 'Vencido'}`,
                tareas: (procedimiento.tareas != undefined) ? [...procedimiento.tareas.map(t => {return {...t, label: t.name, showDescrp: t.showDescrp, value: t.codTarea, taskDescrp:  t.taskDescrp ?? '', done:false}}),{...estructuraTarea}] : [{...estructuraTarea}],
                peligros: (globalSettings?.ODTcheckboxPeligros) ? [] : [{...estructuraPeligro}],
                epps: (globalSettings?.ODTcheckboxEPP) ? [] : [{...estructuraEpp}],
                herramientas: (globalSettings?.ODTcheckboxHerramientas) ? [] : [{...estructuraHerramienta}],
                eqpgs: (globalSettings?.ODTcheckboxEQPG) ? [] : [{...estructuraEqpg}],
                productos: (procedimiento.productos == undefined || procedimiento.productos.length == 0) ? [{...estructura_producto}] : [...procedimiento.productos,{...estructura_producto}],
                imputaciones: [{...estructuraImputaciónRRHH}],
                checklists: procedimiento.checklists.slice(),
                proveedores: (procedimiento.proveedores && procedimiento.proveedores.length > 0) ? [...procedimiento.proveedores, {...createEstructuraProveedor()}] : [{...createEstructuraProveedor()}]
            }
            setRequeriment(JSON.parse(JSON.stringify(reqModelado)));
        }
    },[procedimiento])

    //Sobre varios procedimientos que se van a trabajar a la vez, tildados.
    useEffect(()=>{
        if(procedimientos != undefined && procedimientos.length > 0){
            let title = `Orden de Trabajo s/`;
            let activo;
            let observ = `Generando Orden de Trabajo sobre`;
            let tareas = [];
            let productos = [];
            let checklists = [];
            
            procedimientos.forEach((p,i) => {
                title += ` ${p.codProc} /`;
                activo = {id:p.activoID, value: p.codActivo, label:p.nameActivo};
                observ += ` ${p.nameProcedimiento} ${i == procedimientos.length - 1 ? '' : '/'}`;
                tareas = [...tareas, ...(p.tareas ? p.tareas.map(t => {return {...t, label: t.descrp, value: t.codTarea, taskDescrp: t.taskDescrp ?? '', done:false}}) : [])];
                productos = [...productos, ...((p.productos && p.productos.length > 0) ? [...p.productos] : [])];
                checklists = [...checklists, ...p.checklists];
            })
            tareas.push({...estructuraTarea, done: false});
            productos.push({...estructura_producto});

            title += `- ${procedimientos[0].codActivo}`;
            observ += ` asociados al activo ${procedimientos[0].codActivo} (${procedimientos[0].nameActivo}`

            let reqModelado = {
                title,
                activo,
                observ,
                tareas,
                peligros: (globalSettings?.ODTcheckboxPeligros) ? [] : [{...estructuraPeligro}],
                epps: (globalSettings?.ODTcheckboxEPP) ? [] : [{...estructuraEpp}],
                herramientas: (globalSettings?.ODTcheckboxHerramientas) ? [] : [{...estructuraHerramienta}],
                eqpgs: (globalSettings?.ODTcheckboxEQPG) ? [] : [{...estructuraEqpg}],
                productos,
                imputaciones: [{...estructuraImputaciónRRHH}],
                checklists,
                proveedores:  [{...createEstructuraProveedor()}]
                // proveedores: (procedimiento.proveedores && procedimiento.proveedores.length > 0) ? [...procedimiento.proveedores, {...createEstructuraProveedor()}] : [{...createEstructuraProveedor()}]
            }
            setRequeriment(JSON.parse(JSON.stringify(reqModelado)));
        }
    },[procedimientos])

    /*
        Los materiales que vienen de procedimiento/s traen el precio guardado en el procedimiento, que puede estar desactualizado o no existir.
        Se reemplaza por el precio actual del ABM una sola vez, cuando ya estan cargados tanto los productos del ABM (se piden al montar AddReq) como los de la ODT.
        Declarado despues de los useEffect de procedimiento/s para que se aplique sobre el requerimiento ya armado.
    */
    useEffect(()=>{
        const vieneDeProcedimientos = (procedimiento != undefined && Object.keys(procedimiento).length > 0) || (procedimientos != undefined && procedimientos.length > 0);
        if(!vieneDeProcedimientos || preciosABMAplicadosRef.current || !productsABM || productsABM.length == 0) return;
        preciosABMAplicadosRef.current = true;
        setRequeriment(prevReq => {
            const productos = (prevReq.productos ?? []).map(p => {
                if(!p.tipPro) return p;
                const abm = productsABM.find(a => a.tipPro == p.tipPro && a.artCod == p.artCod);
                return (abm && abm.precio != undefined) ? {...p, precio: abm.precio} : p;
            });
            let importeTotalProductos = 0;
            productos.forEach(p => {
                if(p.precio != undefined) importeTotalProductos += Number.parseInt(p.quantity) * p.precio
            });
            return {...prevReq, productos, importeTotalProductos};
        });
    },[productsABM, procedimiento, procedimientos])

    //Al editar una ODT.
    useEffect(()=>{
        if(procedimiento != undefined && Object.keys(procedimiento).length == 0  && req != undefined && Object.keys(req).length > 0 ){
            let reqModelado = {...req};

            let productosModelados = (req.productos && req.productos.length > 0) ? req.productos.slice() : [{...estructura_producto}];
            
            let tareasModeladas = (req.tareas && req.tareas.length > 0) ? req.tareas.map((t) => ({...t, label: t.name, value:t.codTarea})) : [{...estructuraTarea}];

            let peligrosModelados = (req.peligros && req.peligros.length > 0) ? req.peligros.map((p) => ({...p, label: p.name, value:p.codPeligro})) : ((globalSettings?.ODTcheckboxPeligros) ? [] : [{...estructuraPeligro}]);

            let eppsModelados = (req.epps && req.epps.length > 0) ? req.epps.map((e) => ({...e, label: e.name, value:e.codEpp})) : ((globalSettings?.ODTcheckboxEPP) ? [] : [{...estructuraEpp}]);

            let herramientasModeladas = (req.herramientas && req.herramientas.length > 0) ? req.herramientas.map((h) => ({...h, label: h.name, value:h.codHerramienta})) : ((globalSettings?.ODTcheckboxHerramientas) ? [] : [{...estructuraHerramienta}]);

            let eqpgsModelados = (req.eqpgs && req.eqpgs.length > 0) ? req.eqpgs.map((eq) => ({...eq, label: eq.name, value:eq.codEqpg})) : ((globalSettings?.ODTcheckboxEQPG) ? [] : [{...estructuraEqpg}]);

            let imputacionesModeladas = (req.imputaciones && req.imputaciones.length > 0) ? req.imputaciones.slice() : [{...estructuraImputaciónRRHH}];
            
            let controlesModelados = (req.controlesFallidos && req.controlesFallidos.length > 0) ? req.controlesFallidos.map((ctrl, i) => ({...ctrl, label: ctrl.descrp, value: ctrl.codControl})) : [{...estructuraTarea}];

            let proveedoresModelados = (req.proveedores && req.proveedores.length > 0) ? req.proveedores.slice() : [{...createEstructuraProveedor()}]
            
            if(productosModelados[0].artCod != '') productosModelados.push({...estructura_producto});
            if(tareasModeladas[0].label != '') tareasModeladas.push({...estructuraTarea});
            if(!globalSettings?.ODTcheckboxPeligros && peligrosModelados.length > 0 && peligrosModelados[0].label != '') peligrosModelados.push({...estructuraPeligro});
            if(!globalSettings?.ODTcheckboxEPP && eppsModelados.length > 0 && eppsModelados[0].label != '') eppsModelados.push({...estructuraEpp});
            if(!globalSettings?.ODTcheckboxHerramientas && herramientasModeladas.length > 0 && herramientasModeladas[0].label != '') herramientasModeladas.push({...estructuraHerramienta});
            if(!globalSettings?.ODTcheckboxEQPG && eqpgsModelados.length > 0 && eqpgsModelados[0].label != '') eqpgsModelados.push({...estructuraEqpg});
            if(imputacionesModeladas[0].legajo.label != '') imputacionesModeladas.push({...estructuraImputaciónRRHH});
            if(proveedoresModelados[0].proveedor.label != '') proveedoresModelados.push({...createEstructuraProveedor()});
            //El modelado tanto de las imputacionesRRHH como de proveedores se realiza en el backend.

            reqModelado.productos =  productosModelados;
            reqModelado.tareas = tareasModeladas;
            reqModelado.peligros = peligrosModelados;
            reqModelado.epps = eppsModelados;
            reqModelado.herramientas = herramientasModeladas;
            reqModelado.eqpgs = eqpgsModelados;
            reqModelado.imputaciones = imputacionesModeladas;
            reqModelado.controles = controlesModelados;
            reqModelado.proveedores = proveedoresModelados;

            let docDeepCopy = JSON.parse(JSON.stringify(reqModelado));
            setRequeriment(docDeepCopy);
        }
    },[req])

    return (
        <div className='container-gr-addreq' id={mode == 'editOTFromActivos' || mode == 'normal' ? 'fullScreen' : ''}>
            <div className='container-r-list-item-header'>
                <div className='header-top-row'>
                    <input placeholder='Ingrese un título...' className='list-item-header-title-addReq' value={requeriment.title} onChange={(data) => handleChangeTitle(data.target.value)} autoFocus={true} style={{ fontWeight: "bold" }} ></input>
                    <div className='container-prioritys-gral'>
                        <div className={requeriment.priority === 2 ? 'r-list-item-header-priority-urgente  margin-right-r' : requeriment.priority === 1 ? 'r-list-item-header-priority-alta  margin-right-r' : 'r-list-item-header-priority-media  margin-right-r'} onClick={displayOpciones}>
                            {PRIORITY[requeriment.priority ? requeriment.priority : 0]}
                        </div>
                        {displayOptions &&
                            <div className='options-container-fr  margin-right-r'>
                                <div className='options-container-fr-back'>
                                    {PRIORITY.map((prior) => {
                                        return (
                                            <div key={prior} className={PRIORITYIN[prior] === 2 ? 'r-list-item-header-priority-urgente' : PRIORITYIN[prior] === 1 ? 'r-list-item-header-priority-alta' : 'r-list-item-header-priority-media'} value={prior} onClick={() => seleccionarPriority(PRIORITYIN[prior])}>{prior}</div>
                                        );
                                    })}
                                </div>
                            </div>
                        }
                    </div>
                    <button
                        className='ocultarControlesBtn'
                        onClick={() => setMostrarControles(!mostrarControles)}
                    >
                        <FontAwesomeIcon icon={mostrarControles ? faEyeSlash : faEye} />
                        <span>{mostrarControles ? 'Ocultar controles' : 'Mostrar controles'}</span>
                    </button>
                    {edicion &&
                        <button className='minimizarBtn' onClick={() => cerrar()}>X</button>
                    }
                </div>
            </div>

            {mostrarControles && <><div className="container-AddReq-item-activoAndDeliveryDate">
                {(requeriment.tDocCodFor != undefined && requeriment.tDocNroFor != undefined) && <div className='comprobanteDiv'> 
                    <span>Comprobante: <label>{`${requeriment.tDocCodFor} - ${requeriment.tDocNroFor}`}</label></span>
                </div>}

                <div className='container-AddReq-item-activo'> <span>Activo:</span>
                    <Select
                        styles={{
                        input: (base) => ({
                            ...base,
                            width: "100%",
                            padding: ".4rem",
                            borderRadius: ".5rem",
                            fontSize: "1rem",
                            transition: "border-color .5s"
                        })
                    }}
                    placeholder="Elija el activo que corresponda..."
                    options={optionsActivos}
                    isDisabled={(req != undefined) || (mode != undefined && mode == 'editOTFromActivos') || procedimiento.codActivo != undefined ? true : false}
                    value={requeriment.activo?.label ? requeriment.activo : {label: requeriment.activoCompleto?.name, value: requeriment.activoCompleto?.codActivo}}
                    onChange={(selectedOption) => handleChengeActivo(selectedOption)}/>        
                </div>

                <div className='container-r-duracion'>
                    <span>Duración en HS:</span>
                    <input type='number' name='duracion' value={requeriment.duracion} onChange={(e)=>setRequeriment({...requeriment, [e.target.name]: Number.parseInt(e.target.value)})}></input>
                </div>

                <div className="container-r-item-title-details deliveryDate">
                    <label>Fecha de Entrega</label>
                    <input
                        type="date"
                        className="label-AddReq-fecha"
                        value={moment(requeriment.deliveryDate).format("YYYY-MM-DD")}
                        onChange={(data) => handleChangeDeliveryData(data.target.value)}
                    />
                </div>
            
                <div className='envioExternoDiv'>
                    <label>Envío Externo {'>>>'}</label>
                    <div className="checkboxContainer">
                        <input type='checkbox' onChange={(e) => handleChangeEnvioExterno(e)} value={requeriment.envioExterno} checked={requeriment.envioExterno}/>
                    </div>
                </div>
            </div>

            <div className='container-texto-y-checkboxes'>
                <div className='container-AddReq-item-details-text'>
                    <div className='container-r-item-title-details'>Texto Adicional</div>
                    <div className='container-input-texto'>
                        <div className='r-list-item-details-data-v'><textarea placeholder='Ingrese texto adicional' className='r-item-text-input' style={{ fontWeight: 600 }} value={requeriment.observ} onChange={(data) => handleChangObservation(data.target.value)}></textarea></div>
                    </div>
                </div>
                <div className='header-checkboxes-column'>
                    <div className='header-checkbox-item'>
                        <input type='checkbox' id='superposicionTareas' checked={requeriment.superposicionTareas || false} onChange={(e) => setRequeriment({...requeriment, superposicionTareas: e.target.checked})}/>
                        <label htmlFor='superposicionTareas'>Hay superposición de tareas con operaciones</label>
                    </div>
                    <div className='header-checkbox-item'>
                        <input type='checkbox' id='bloquearEquipos' checked={requeriment.bloquearEquipos || false} onChange={(e) => setRequeriment({...requeriment, bloquearEquipos: e.target.checked, bloquearEquiposCual: e.target.checked ? requeriment.bloquearEquiposCual : ''})}/>
                        <label htmlFor='bloquearEquipos'>Es necesario bloquear equipos</label>
                        {requeriment.bloquearEquipos &&
                            <div className='header-checkbox-cual'>
                                <label>Cuál?</label>
                                <input type='text' placeholder='Ingrese cuál...' value={requeriment.bloquearEquiposCual || ''} onChange={(e) => setRequeriment({...requeriment, bloquearEquiposCual: e.target.value})}/>
                            </div>
                        }
                    </div>
                </div>
            </div></>}

            <div className="tablasHijasDiv">
                <div className="opcionesHijasDiv">
                    <button className={(tablaSeleccionada === 'tareas') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('tareas')}>Tareas</button>
                    <button className={(tablaSeleccionada === 'componentes') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('componentes')}>Materiales</button>
                    <button className={(tablaSeleccionada === 'imputaciones') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('imputaciones')}>Imputaciones RRHH</button>
                    <button className={(tablaSeleccionada === 'servTerceros') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('servTerceros')}>Serv. de Terceros</button>
                    {requeriment.originado == 'CHECKLIST' && <button className={(tablaSeleccionada === 'controles') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('controles')}>Controles Fallidos</button>}
                    {requeriment.checklists && requeriment.checklists.length > 0 && <button className={(tablaSeleccionada === 'checklists') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('checklists')}>Checklists</button>}
                    {(globalSettings?.ODTshowPeligros ?? true) && <button className={(tablaSeleccionada === 'peligros') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('peligros')}>Peligros Posibles</button>}
                    {(globalSettings?.ODTshowHerramientas ?? true) && <button className={(tablaSeleccionada === 'herramientas') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('herramientas')}>Herramientas</button>}
                    {(globalSettings?.ODTshowEPP ?? true) && <button className={(tablaSeleccionada === 'epps') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('epps')}>EPP</button>}
                    {(globalSettings?.ODTshowEQPG ?? true) && <button className={(tablaSeleccionada === 'eqpgs') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('eqpgs')}>EQPG</button>}
                </div>
                <ProductosSubtabla req={requeriment} setState={setRequeriment} productos={requeriment.productos} handleChangeProductos={handleChangeProductos} componentePadre='FormReq' handleDeleteProd={handleDeleteProd} tablaSeleccionada={tablaSeleccionada} hasWebServiceConfigured={hasWebServiceConfigured}/>
                
                <TareasSubtabla tareas={requeriment.tareas} setState={setRequeriment} completedTasks={completedTasks} tablaSeleccionada={tablaSeleccionada} componentePadre='FormReq' tipo={'tareaOT'} handleChangeCheckTask={handleChangeCheckTask} tDocID={requeriment._id}/>

                {(globalSettings?.ODTshowPeligros ?? true) && <PeligrosSubtabla peligros={requeriment.peligros} setState={setRequeriment} tablaSeleccionada={tablaSeleccionada} tDocID={requeriment._id} checkboxMode={globalSettings?.ODTcheckboxPeligros ?? false}/>}

                {(globalSettings?.ODTshowEPP ?? true) && <EppsSubtabla epps={requeriment.epps} setState={setRequeriment} tablaSeleccionada={tablaSeleccionada} tDocID={requeriment._id} checkboxMode={globalSettings?.ODTcheckboxEPP ?? false}/>}

                {(globalSettings?.ODTshowHerramientas ?? true) && <HerramientasSubtabla herramientas={requeriment.herramientas} setState={setRequeriment} tablaSeleccionada={tablaSeleccionada} tDocID={requeriment._id} checkboxMode={globalSettings?.ODTcheckboxHerramientas ?? false}/>}

                {(globalSettings?.ODTshowEQPG ?? true) && <EqpgsSubtabla eqpgs={requeriment.eqpgs} setState={setRequeriment} tablaSeleccionada={tablaSeleccionada} tDocID={requeriment._id} checkboxMode={globalSettings?.ODTcheckboxEQPG ?? false}/>}

                <ImputacionRRHHSubtabla imputaciones={requeriment.imputaciones} tablaSeleccionada={tablaSeleccionada} handleChangeImputaciones={handleChangeImputaciones} handleDeleteImputaciones={handleDeleteImputaciones} componentePadre='FormReq' tipo={'tareaOT'}/>
                
                <ServTercerosSubtabla req={requeriment} setState={setRequeriment} proveedores={requeriment.proveedores} tablaSeleccionada={tablaSeleccionada} handleChangeProveedores={handleChangeProveedores} handleDeleteProveedores={handleDeleteProveedores} componentePadre='FormReq' tipo={'tareaOT'} hasWebServiceConfigured={hasWebServiceConfigured}/>
                
                <ControlesSubtabla controles={requeriment.controles} tablaSeleccionada={tablaSeleccionada} componentePadre='FormReq' tipo={'controlOT'} setState={setRequeriment}/>
                
                {requeriment.checklists && requeriment.checklists.length > 0 && <ChecklistsSubtabla checklists={requeriment.checklists ? requeriment.checklists : [createEstructuraChecklistsByProcedimiento()]} tablaSeleccionada={tablaSeleccionada} modo={'View'} componentePadre='FormReq'/>}
            </div>

            <BtnArchivos files={files} selectedFiles={selectedFiles} setSelectedFiles={setSelectedFiles} archivoTotal={archivoTotal} setArchivoTotal={setArchivoTotal}/>

            <div className='container-button-rq-save-new'  >
                <button className='button-rq-save-new' style={{backgroundColor: COLOR_BOTONES}} disabled={controlBotonEnviar} onClick={handleSaveRequirement}>
                    Guardar
                </button>
            </div>

        </div>
    );
}

export default FormReq